var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-12 has-text-centered"},[_c('h1',{staticClass:"title is-1"},[_vm._v("Oeps..."),_c('br'),_vm._v("404 not found")])])
}]

export { render, staticRenderFns }